<script lang="ts" setup>
import type { Category } from '~/types/Category';

defineProps<{ category: Category }>();
</script>

<template>
  <CardBlock class="flex items-center gap-4 !py-2 sm:!py-3">
    <img
      :alt="category.name"
      :src="category.svg_url || '/images/puzzle.svg'"
      class="size-6 sm:size-12"
    />

    <span class="text-sm">
      {{ category.name }}
    </span>
  </CardBlock>
</template>
